import { z } from 'zod';

export const VisitTypeSchema = z.enum(['PICKUP', 'DELIVERY']);

export const AddShippingsToRouteSchema = z.object({
  shippingNumbers: z
    .array(z.number().int().positive('Cada número debe ser un entero positivo'))
    .min(1, 'Debe incluir al menos un pedido'),
  type: VisitTypeSchema.optional(),
  lat: z.number().optional(),
  long: z.number().optional(),
});

export type AddShippingsToRouteInput = z.infer<typeof AddShippingsToRouteSchema>;
